import { Outlet, useNavigate, useLocation } from "react-router-dom";
import { User, LogOut } from "lucide-react";
import { useState } from "react";
import ProfileModal from "./settings/ProfileModal";
import Footer from "../components/layout/Footer";
import "../styles/AdminLayout.css";

const AdminLayout = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [showProfile, setShowProfile] = useState(false);

  const user = JSON.parse(localStorage.getItem("user"));
  const role = user?.role?.toLowerCase();   // ✅ FIX
  const isAdmin = role === "admin";         // ✅ FIX

  return (
    <div className="admin-container">
      {/* ===== TOP BAR ===== */}
      <div className="admin-topbar">
        <div className="topbar-left">
          <img
            src={require("../assets/image.png")}
            alt="JT Attorney Alliance"
            className="brand-logo"
            onClick={() => navigate("/admin")}
            style={{ cursor: "pointer", width: 155, height: "auto", objectFit: "contain" }}
          />

          <button
            className={
              location.pathname === "/admin" ? "tab-btn active" : "tab-btn"
            }
            onClick={() => navigate("/admin")}
          >
            Draft Generator
          </button>
		  
		  <button
            className={
              location.pathname === "/admin/alldrafts" ? "tab-btn active" : "tab-btn"
            }
            onClick={() => navigate("/admin/alldrafts")}
          >
            All Drafts
          </button>

          {isAdmin && (
            <button
              className={
                location.pathname.startsWith("/admin/settings")
                  ? "tab-btn active"
                  : "tab-btn"
              }
              onClick={() => navigate("/admin/settings/users")}
            >
              Settings
            </button>
          )}
        </div>

        <div className="topbar-right">
          <button
            className="icon-btn"
            onClick={() => setShowProfile(true)}
          >
            <User size={20} />
          </button>

          <button
            className="icon-btn"
            onClick={() => {
              localStorage.clear();
              navigate("/login", { replace: true });
            }}
          >
            <LogOut size={20} />
          </button>
        </div>
      </div>

      {/* ===== PAGE CONTENT ===== */}
      <div className="admin-content">
        <Outlet />
      </div>

      <Footer />

      {showProfile && (
        <ProfileModal onClose={() => setShowProfile(false)} />
      )}
    </div>
  );
};

export default AdminLayout;
